<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <span class="breadcrumb-link">{{ 'Special Events' }} </span>
        </li>
      </ol>
    </nav>

    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'Special Events' }}
      </h1>

      <div>
        <button
          *ngIf="!hideCreateRoleButton"
          class="btn btn-primary"
          (click)="onClickCreate()"
          [canSee]="[accessRights.RolePermissions_write]"
          type="button"
        >
          {{ 'general.createRole' | translate }}
        </button>
        <button
          class="btn btn-primary"
          *ngIf="hideCreateRoleButton"
          type="button"
          (click)="addTileRow()"
          [canSee]="[accessRights.RolePermissions_write]"
        >
          {{ 'shopModule.addNewTile' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->
  <!-- Nav -->
  <nav attr.aria-label="{{ 'wcag.rolePermissionsMenu' | translate }}">
    <ul class="nav nav-tabs align-items-center mb-3" role="tablist">
      <!-- WCAG SKIP link -->
      <!-- <li class="nav-item">
        <a
          class="nav-link visually-hidden-focusable"
          href="#rolePermissionContent"
          >{{ 'wcag.skipNavigation' | translate }}</a
        > </li
      > -->
      <!-- END WCAG skip link -->
      <li class="nav-item">
        <a
          href="javascript:;"
          (click)="onClickSelectedType('role-permissions')"
          [ngClass]="{ active: form.value.selectedType == 'role-permissions' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="
            form.value.selectedType == 'role-permissions' ? 'true' : 'false'
          "
          aria-controls="panel-role-permissions"
        >
          <i role="img" class="fa fa-calendar-alt" aria-hidden="true"></i>
          {{ 'rolePermissionsModule.rolePermissions' | translate }}
        </a>
      </li>
      <li class="nav-item">
        <a
          href="javascript:;"
          (click)="onClickSelectedType('tiles')"
          [ngClass]="{ active: form.value.selectedType == 'tiles' }"
          class="nav-link"
          role="tab"
          [attr.aria-selected]="
            form.value.selectedType == 'tiles' ? 'true' : 'false'
          "
          aria-controls="panel-tiles"
        >
          <i role="img" class="fa fa-border-all" aria-hidden="true"></i>
          {{ 'shopModule.shopTiles' | translate }}
        </a>
      </li>
    </ul>
  </nav>

  <!-- End Nav -->
  <div
    *ngIf="isLoading$ | async"
    class="spinner-border"
    role="status"
    attr.aria-label="{{ 'general.loading' | translate }}"
  >
  </div>

  <div id="rolePermissionContent">
    <role-permissions-table
      id="panel-role-permissions"
      *ngIf="form.value.selectedType === 'role-permissions'"
      [tableData]="rolePermissions$ | async"
      [showTotal]="true"
      [removeSearchTerm$]="removeSearchTerm$.asObservable()"
      [showPageFooter]="true"
      [limitPage]="limit"
      [activePage]="page"
      [key]="field"
      [total]="total"
      [pageCount]="pageCount"
      (searchTerm)="onSearchTerm($event)"
      (onSelectedPage)="selectNewPage($event)"
      (onSelectLimit)="selectNewLimit($event)"
      (onSearchTerm)="onSearchTerm($event)"
      (onBulkAction)="onBulkAction($event)"
      (onClickRow)="onClickRow($event)"
      [bulkActions]="[BulkAction.DELETE]"
      (onSortedTable)="onSorted($event)"
    ></role-permissions-table>

    <configuration-option-organization-tab
      id="panel-tiles"
      *ngIf="form.value.selectedType === 'tiles'"
      [onClickCreateTile$]="onClickCreateTile$"
    >
    </configuration-option-organization-tab>
  </div>
</div>
